import { useCompanyId } from 'application/providers/AccountProvider';
import { useUploadMediaFilesMutation } from 'domain/api/graphql/generated';
import useVideoMeiafiles from 'domain/company/useCompanyMediafiles';

export const useVideoMediafiesPresenter = (query?: string) => {
  const companyId = useCompanyId();

  const [uploadMediaFilesMutation] = useUploadMediaFilesMutation();

  const {
    companyMediafiles,
    refetch,
    loading,
    getMoreCompanyMediafiles,
    companyMediafilesPaginationInfo: paginationInfo,
  } = useVideoMeiafiles(companyId, query);

  return {
    videoMediafiles: companyMediafiles || undefined,
    loading,
    refetch,
    loadMore: getMoreCompanyMediafiles,
    companyId,
    uploadMediaFilesMutation,
    paginationInfo,
  };
};
